export * from './icons'
import * as SharedImages from './images'

export { SharedImages }